import {IDeserializeContext, IModelSchema} from '@mintdata/mint-kit/impl/util/serializr/src/api/types';
import {isModelSchema} from '../utils/utils';

export const frameModelSchema:IModelSchema = {
    factory: (context:IDeserializeContext) =>
    {
        const Frames = require('@mintdata/mint-kit/api/values/frames/Frames').Frames;

        return Frames.fromJSONObject(
            context && context.json
                ? context.json
                : {}
        );
    },
    props: {}
};

/**
 * Returns the standard model schema associated with a class / constructor function
 *
 * @param {object} thing
 * @returns {ModelSchema} model schema
 */
export function getDefaultModelSchema(thing:any):IModelSchema
{
    const AError = require('@mintdata/mint-kit/api/values/AError').AError;

    if( !thing )
        return null;

    if( AError && AError.isSerializedErrorValue(thing) )
        return getDefaultModelSchema(AError);

    if( thing.isFrame )
        return frameModelSchema;

    if( isModelSchema(thing) )
        return thing;

    if( isModelSchema(thing.serializeInfo) )
        return thing.serializeInfo;

    if( thing.constructor && thing.constructor.serializeInfo )
        return thing.constructor.serializeInfo;
}
